import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { HistoryItemEntity } from './history-item.entity';
import { HistoryListEntity } from './history-list.entity';

@Injectable()
export class HistoryListProvider {
	private readonly historyList: HistoryListEntity;

	public constructor() {
		this.historyList = HistoryListEntity.build([
			{
				field: 'status',
				alias: $localize`:i18n=@@subscription.history.list.column.status:`,
				type: 'string',
				isSearchable: false,
				hasHeaderFilter: true,
				isFilterable: false,
				visibleIndex: 0,
			},
			{
				field: 'action',
				alias: $localize`:i18n=@@subscription.history.list.column.action:`,
				type: '',
				isSearchable: true,
				hasHeaderFilter: true,
				visibleIndex: 1,
			},
			{
				field: 'columnCount',
				alias: $localize`:i18n=@@subscription.history.list.column.columnCount:`,
				type: 'number',
				isSearchable: false,
				hasHeaderFilter: true,
				isFilterable: true,
				visibleIndex: 2,
			},
			{
				field: 'lineCount',
				alias: $localize`:i18n=@@subscription.history.list.column.lineCount:`,
				type: 'number',
				isSearchable: false,
				hasHeaderFilter: true,
				isFilterable: true,
				visibleIndex: 3,
			},
			{
				field: 'date',
				alias: $localize`:i18n=@@subscription.history.list.column.date:`,
				type: 'number',
				isSearchable: false,
				hasHeaderFilter: true,
				isFilterable: true,
				visibleIndex: 4,
			},
			{
				field: 'duration',
				alias: $localize`:i18n=@@subscription.history.list.column.duration:`,
				type: 'number',
				isSearchable: false,
				hasHeaderFilter: true,
				isFilterable: true,
				visibleIndex: 4,
			},
			{
				field: 'avatar',
				alias: $localize`:i18n=@@subscription.history.list.column.avatar:`,
				type: '',
				isSearchable: false,
				hasHeaderFilter: false,
				isFilterable: false,
				visibleIndex: 5,
			},
		]);
	}

	public getList(): HistoryListEntity {
		return this.historyList;
	}

	public setListElements(
		elements: Map<string, HistoryItemEntity>
	): HistoryListEntity {
		return this.historyList.setElements(elements);
	}
}
